import { FC } from "react";
import { List } from "../List/List";
import { Pragraph } from "../Pragraph/Pragraph";

export const FirstSection: FC = () => {
  return (
    <li>
      <div>1. 取得する個⼈情報の項⽬</div>
      <Pragraph>当社は、お客様に関する次に掲げる個⼈情報を取得します。</Pragraph>
      <List
        items={[
          {
            index: "⑴",
            title: "お問合せフォームにご⼊⼒いただいた情報",
            text: "⽒名、メールアドレス、お問合せ内容等",
          },
          {
            index: "⑵",
            title: "サービスのご利⽤に際して取得する情報",
            text: "ご利⽤の端末情報、アクセスログ、IPアドレス、ブラウザ情報、ブラウザの⾔語設定等",
          },
        ]}
      />
    </li>
  );
};
